import { Modal } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { AppThemeType } from 'store/types';
import styled from 'styled-components';

export const ErrorNotice = styled.p`
  color: ${({ theme }) => theme.text.onSurface.negative};
`;

export const CompanyModalWrapper = styled(Modal)<{
  $showMask: boolean;
  $appTheme: AppThemeType;
}>`
  &.shell-modal.shell-modal-container-wrap {
    z-index: 100;
  }

  &.shell-modal.shell-modal-container-mask {
    z-index: 2;
  }

  .shell-modal-container {
    width: 572px !important; // ugly but need to set it to counter hard-coded 520px width

    @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
      width: 100vw !important; // ugly but need to set it to counter hard-coded 520px width
      position: fixed;
      top: 0;
      left: 0;
    }
  }

  ${({ theme, $showMask, $appTheme }) => `
    &.shell-modal.shell-modal-container-mask {
      ${
        $showMask &&
        `background-color: ${$appTheme === 'light' ? '#F5F5F5;' : `${theme.background.base};`}`
      }
  `}

  .shell-modal-container-body, .shell-modal-container-content {
    border-radius: 0;
    @media screen and (min-width: ${cxTheme.breakpoints.tablet}px) {
      border-radius: 6px;
    }
  }

  .shell-modal-container-content {
    @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
      height: 100vh;
    }
  }
`;

export const LoadMoreButtonContainer = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;
